import { render, staticRenderFns } from "./expertise.vue?vue&type=template&id=0836d9fe&"
import script from "./expertise.vue?vue&type=script&lang=js&"
export * from "./expertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports